import { LDS_URL } from 'marketplace/api/lds-http-client';
const DEV_MODE_KEY = 'rl-dev-mode';
const isDevMode = new URLSearchParams(window.location.search).get(DEV_MODE_KEY) === 'true' || localStorage.getItem(DEV_MODE_KEY) === 'true';
const combineAndResolvePath = (path)=>{
    return `${LDS_URL}/${path}`;
};
export const LdsUtils = {
    isDevModeOn: ()=>{
        return isDevMode;
    },
    combineAndResolvePath
};
